import Projects from './sites/projects.js';
import About from './sites/about.js';
import Imprint from './sites/imprint.js';

(function () {
	const subpages = {
		projects: new Projects(),
		about: new About(),
		imprint: new Imprint(),
	};

	const langswitchAElements = document.querySelectorAll('.mainnav--langswitch a');

	function updateLangswitch() {
		const { hash } = location;

		[...langswitchAElements].forEach((langswitchAElement) => {
			langswitchAElement.href = langswitchAElement.dataset.href + hash;
		});
	}

	function openCloseSites() {
		let hash = location.hash.substr(2);

		if (hash.indexOf(':') !== -1) {
			hash = hash.slice(0, hash.indexOf(':'));
		}
		if (hash.indexOf('/') !== -1) {
			hash = hash.slice(0, hash.indexOf('/'));
		}

		Object.values(subpages).forEach((subpage) => {
			subpage.close();
		});

		if (hash === '' || hash === 'projects') {
			subpages.projects.open();
		} else if (hash === 'blog') {
			subpages.blog.open();
		} else if (hash === 'shop') {
			subpages.shop.open();
		} else if (hash === 'about') {
			subpages.about.open();
		} else if (hash === 'imprint') {
			subpages.imprint.open();
		}

		updateLangswitch();
	}

	openCloseSites();
	updateLangswitch();

	window.addEventListener('hashchange', openCloseSites);
}());
